import { CurrentAccountViewData } from 'models/account'
import { createContext } from 'react'

export const AccountContext = createContext<CurrentAccountViewData | null>(null)
